class SkateSharpening extends HTMLElement {
    constructor() {
      super();
      
      this.hiddenInput = this.querySelector('input[type="hidden"]');
      this.sharpeningInputs = this.querySelectorAll('input[type="radio"]');

      this.sharpeningInputs[0].checked = true;
      this.hiddenInput.value = this.sharpeningInputs[0].dataset.hiddenValue;
    
      this.addEventListener('change', this.onOptionProductChange.bind(this));
    }
      
    onOptionProductChange(event) {
      this.hiddenInput.value = event.target.dataset.hiddenValue;
    }
  }
  
  customElements.define('skate-sharpening', SkateSharpening);
  